<template>
    <div class="flex-col">
        <vnavbar title="耗材清点" class="backbar" left-text="返回" left-arrow @click-left="back" />
        <vcellgroup>
            <vfield v-model="nodeName" label="节点:" />
            <vsearch placeholder="请输入搜索关键词" v-model="searchValue" :show-action="showAction"
                @cancel="onCancel" @focus="onFocus" @input="onSearch">
                <!-- <div slot="action" @click="searchValue ? onSearch : onCancel">
                    {{ searchValue ? '搜索' : '取消' }}
                </div> -->
            </vsearch>
            <vfield v-model="nodeNumber" type="number" label="数量" />
        </vcellgroup>
            <vpullrefresh v-model="refreshing" @refresh="onRefresh">
                <vlist v-model="loading" :finished="finished" finished-text="" @load="onLoad">
                    <!-- <div v-for="(item,index) in supplys" :key="index">{{item.dic_supplies_name}}</div> -->
                        <vradiogroup v-model="selectedSuppliesId">
                            <vradio style="font-size:22px;" v-for="(item,index) in _supplys" :key="index" :name="item.dic_supplies_id">{{item.dic_supplies_name}}</vradio>
                        </vradiogroup>
                    <!-- <div class="content">
                        <vradiogroup v-model="selectedSupply">
                            <vradio v-for="(s,index) in supplys" :key="index" :name="s">{{s}}</vradio>
                        </vradiogroup>
                    </div> -->
                </vlist>
            </vpullrefresh>
        <div class="bottom">
            <vbutton class="btnTrans" type="info" @click="createCountingNode">确认</vbutton>
            <vbutton class="btnTrans" type="info" @click="createCountingNode">确认并继续新增</vbutton>
        </div>
        <vnumberkeyboard :show="show" extra-key="." close-button-text="完成" />
    </div>
</template>

<script>
import { RadioGroup as vradiogroup, Radio as vradio, PullRefresh as vpullrefresh, List as vlist, Empty as vempty, NumberKeyboard as vnumberkeyboard, Search as vsearch, CellGroup as vcellgroup, Field as vfield, Tab as vtab, Tabs as vtabs, NavBar as vnavbar, Empty, Button as vbutton, Dialog, Tabbar as vtabbar, TabbarItem as vtabbaritem, Icon as vicon, Tag as vtag } from 'vant'
import 'vant/lib/index.css'
import { mapGetters } from 'vuex'
export default {
    name: `CountSupplyCreate`,
    components: { vradiogroup, vradio, vnumberkeyboard, vpullrefresh, vlist, vempty, vsearch, vcellgroup, vfield, vtab, vtabs, vnavbar, Empty, vtabbar, vtabbaritem, vbutton, [Dialog.Component.name]: Dialog.Component, vicon, vtag },
    data() {
        return {
            surgeryId: this.$route.query.surgeryId,
            surgeryInfo: this.$route.params.surgeryInfo,
            prevPath: this.$route.params.prevPath,
            loading: false,
            finished: false,
            refreshing: false,
            searchValue: ``,
            showAction: false,
            supplys: [
                // {
                //     id: 1,
                //     name: `耗材1`
                // },
                // {
                //     id: 2,
                //     name: `耗材2`
                // },
                // {
                //     id: 3,
                //     name: `耗材3`
                // },
                // {
                //     id: 4,
                //     name: `耗材4`
                // },
                // {
                //     id: 5,
                //     name: `耗材1`
                // },
                // {
                //     id: 6,
                //     name: `耗材2`
                // },
                // {
                //     id: 7,
                //     name: `耗材3`
                // },
                // {
                //     id: 8,
                //     name: `耗材4`
                // },
                // {
                //     id: 9,
                //     name: `耗材9`
                // },
                // {
                //     id: 10,
                //     name: `耗材12`
                // },
                // {
                //     id: 11,
                //     name: `耗材13`
                // },
                // {
                //     id: 12,
                //     name: `耗材14`
                // },
                // {
                //     id: 1,
                //     name: `耗材1`
                // },
                // {
                //     id: 2,
                //     name: `耗材2`
                // },
                // {
                //     id: 3,
                //     name: `耗材3`
                // },
                // {
                //     id: 4,
                //     name: `耗材4`
                // },
                // {
                //     id: 5,
                //     name: `耗材1`
                // },
                // {
                //     id: 6,
                //     name: `耗材2`
                // },
                // {
                //     id: 7,
                //     name: `耗材3`
                // },
                // {
                //     id: 8,
                //     name: `耗材4`
                // },
                // {
                //     id: 9,
                //     name: `耗材9`
                // },
                // {
                //     id: 10,
                //     name: `耗材12`
                // },
                // {
                //     id: 11,
                //     name: `耗材13`
                // },
                // {
                //     id: 12,
                //     name: `耗材14`
                // },
                // {
                //     id: 1,
                //     name: `耗材1`
                // },
                // {
                //     id: 2,
                //     name: `耗材2`
                // },
                // {
                //     id: 3,
                //     name: `耗材3`
                // },
                // {
                //     id: 4,
                //     name: `耗材4`
                // },
                // {
                //     id: 5,
                //     name: `耗材1`
                // },
                // {
                //     id: 6,
                //     name: `耗材2`
                // },
                // {
                //     id: 7,
                //     name: `耗材3`
                // },
                // {
                //     id: 8,
                //     name: `耗材4`
                // },
                // {
                //     id: 9,
                //     name: `耗材9`
                // },
                // {
                //     id: 10,
                //     name: `耗材12`
                // },
                // {
                //     id: 11,
                //     name: `耗材13`
                // },
                // {
                //     id: 12,
                //     name: `耗材14`
                // },
                // {
                //     id: 101,
                //     name: `耗材1`
                // },
                // {
                //     id: 2,
                //     name: `耗材2`
                // },
                // {
                //     id: 3,
                //     name: `耗材3`
                // },
                // {
                //     id: 4,
                //     name: `耗材4`
                // },
                // {
                //     id: 5,
                //     name: `耗材1`
                // },
                // {
                //     id: 6,
                //     name: `耗材2`
                // },
                // {
                //     id: 7,
                //     name: `耗材3`
                // },
                // {
                //     id: 8,
                //     name: `耗材4`
                // },
                // {
                //     id: 9,
                //     name: `耗材9`
                // },
                // {
                //     id: 10,
                //     name: `耗材12`
                // },
                // {
                //     id: 11,
                //     name: `耗材13`
                // },
                // {
                //     id: 12,
                //     name: `耗材14`
                // }
            ],
            nodeName: `术前添加`,
            selectedSuppliesId: 0,
            nodeNumber: 1,
            show: false
        }
    },
    computed: {
        ...mapGetters([`currentUser`, `sysuser/workers`, `screenHeight`, `operation_ward_auth`, `active_hospital_ward`]),
        _supplys() {
            let sk = (this.searchValue && this.searchValue.toUpperCase()) || ``
            let r = _.filter(this.supplys, d => {
                let result = true
                if (result && sk.length > 0) {
                    result =
                        (d.dic_supplies_name.toUpperCase().indexOf(sk) > -1)
                }
                return result
            })
            return r
        }
    },
    created() {
        this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
            this.loadConfig()
        })
    },
    mounted() {},
    methods: {
        loadConfig() {
            let that = this
            let operationwardids = this.operation_ward_auth.map(i => i.value)
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/SuppliesCountingOperatingWardConfig/Get`)
                req.then(data => {
                    data = _.filter(data, d => {
                        return operationwardids.findIndex(i => i == d.dic_operating_ward_id) > -1
                    })
                    let r = _.map(data, (d, index) => {
                        return {
                            dic_supplies_id: d.dic_supplies_id,
                            dic_supplies_name: `${d.supplies_model.name}(${d.supplies_model.code})`
                        }
                    })
                    that.supplys = _.uniqBy(r, `dic_supplies_id`)
                    that.finished = true
                    resolve(that.supplys)
                }).catch(e => {
                    that.finished = true
                })
            })
        },
        onSearch() {
            if (this.searchValue) {
            }
        },
        onFocus() {
            this.showAction = true
        },
        onCancel() {
            this.showAction = false
        },
        aaaa() {
            this.show = true
        },
        createCountingNode() {
            alert(11111)
        },
        back() {
            this.$router.push({ name: `CountSupply`, query: { surgeryId: this.surgeryId }, params: { surgeryInfo: this.surgeryInfo, prevPath: this.prevPath } }).catch(err => err)
        },
        onLoad() {
        },
        onRefresh() {
            let that = this
            this.loadConfig().then(data => {
                this.finished = true
            })
            that.refreshing = false
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            if (newUrl.path == `/t_countsupplycreate`) {
                this.surgeryId = this.$route.query.surgeryId
                this.surgeryInfo = this.$route.params.surgeryInfo
                this.loadConfig()
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import '../mobile_common.css';
.backbar{
    background-color: #04A891;
    border:unset !important;
    /deep/ .van-icon{
        color:#ffffff !important;
    }
    /deep/ .van-nav-bar__text{
        color:#ffffff !important;
    }
    /deep/ .van-nav-bar__title{
        color:#ffffff !important;
    }
}
.van-hairline--bottom::after{
    border-bottom-width:0px !important;
}
.header {
    color:#ffffff !important;
    background: #04A891 !important;
    font-size: 14px;
    text-align: left;
    .patient {
        line-height: 23px;
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        height: 46px;
        .name{
            padding:0 20px;
            font-size: 17px;
        }
    }
    .surgery {
        border-top: 1px dashed #ffffff;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        flex-wrap: wrap;
        div {
            width: 50%;
            height:30px;
            line-height:30px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 500;
            font-size: 16px;
            padding: 0 16px;
        }
        .time{
            flex-basis:100% !important;
        }
    }
    .more{
        align-items: center;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        justify-content: space-between;
        margin: 0 16px;
        padding-bottom: 10px;
        .moredevice{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 500;
            font-size: 16px;
            max-width: 80%;
        }
        }
}
.bottom {
    display: flex;
    position: fixed;
    bottom: 0px;
    width:100%;
    .btnTrans {
        flex:1;
        background: var(--primary-color, #009688);
        margin: 5px;
        height: 40px;
        padding: 0px 30px;
        color: #ffffff;
    }
}

.line{
    margin:0px 24px;
    width:1px;
    height:130px;
    background:#EBEBEB;
}
.scrollContent{
    overflow-y: auto;
    overflow-x: hidden;
}
.content{
    display:flex;
    font-size:20px;
    .panel{
        position: relative;
        width: 100%;
        padding: 0 16px;
        text-align: left;
        .monthday{
            position: absolute;
            left:-40px;
            top:0px;
            opacity: 1;
            background: #fff;
            font-size:18px;
        }
        .date{
            position: absolute;
            left:-40px;
            top:8px;
            opacity: 1;
            background: #fff;
            font-size:18px;
        }
        .step{
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: start;
            font-size: 16px;
            color: rgba(102, 102, 102, 1);
        }
        .steprowone{
            flex-basis: 70%;
            font-weight: 500;
            font-size: 20px;
            color: var(--primary-color, #009688);
            line-height: 36px;
            height: 36px;
            text-align: left;
            font-style: normal;
            overflow-wrap: break-word;
            white-space: nowrap;
            margin-top: 1px;
        }
        .phone{
            background-color: #E0F2EE;
            border-radius: 50%;
            height: 24px;
            width: 24px;
            line-height: 24px;
            text-align: center;
        }
        .steprowtwo{
            flex-basis: 100%;
            margin-top: 5px;
        }
        .remark{
            flex-basis: 90%;
            padding: 5px 10px 10px 0px;
            background-color: rgba(245, 245, 245, 1);
            border-radius: 2px;
        }
    }
    }
</style>



// WEBPACK FOOTER //
// src/components/Mobile/Transfer/CountSupplyCreate.vue